import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiSearch, FiBell, FiUser } from 'react-icons/fi';

export default function Header() {
  return (
    <header className="h-16 border-b border-[var(--border-ocean)] bg-[var(--surface-ocean)]/50 backdrop-blur-md flex items-center justify-between px-8 sticky top-0 z-20">
      <div className="flex-1 max-w-2xl">
        <div className="relative group">
          <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--pearl-muted)] group-focus-within:text-[var(--schema-teal)] transition-colors" />
          <input 
            type="text" 
            placeholder="Search datasets, owners, or tags across the harbor..." 
            className="w-full bg-[var(--bg-ocean)] border border-[var(--border-ocean)] rounded-lg py-2 pl-10 pr-4 text-sm text-[var(--pearl)] focus:outline-none focus:border-[var(--schema-teal)] focus:shadow-[0_0_10px_var(--schema-teal-dim)] transition-all"
          />
          <div className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-1">
             <kbd className="px-2 py-0.5 text-[10px] bg-[var(--surface-ocean-light)] border border-[var(--border-ocean)] rounded text-[var(--pearl-muted)]">⌘</kbd>
             <kbd className="px-2 py-0.5 text-[10px] bg-[var(--surface-ocean-light)] border border-[var(--border-ocean)] rounded text-[var(--pearl-muted)]">K</kbd>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-6 ml-8">
        <button className="relative text-[var(--pearl-muted)] hover:text-[var(--pearl)] transition-colors">
          <SafeIcon icon={FiBell} className="text-xl" />
          <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-[var(--schema-teal)] rounded-full shadow-[0_0_5px_var(--schema-teal)]"></span>
        </button>
        <div className="flex items-center gap-3 pl-6 border-l border-[var(--border-ocean)]">
          <div className="text-right hidden md:block">
            <p className="text-sm font-medium text-[var(--pearl)]">Cmdr. Shepard</p>
            <p className="text-xs text-[var(--schema-teal)]">Chief Data Officer</p>
          </div>
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[var(--surface-ocean-light)] to-[var(--border-ocean)] flex items-center justify-center border border-[var(--schema-teal)]">
             <SafeIcon icon={FiUser} className="text-[var(--pearl)]" />
          </div>
        </div>
      </div>
    </header>
  );
}